import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=98dd31fe&scoped=true"
import script from "./Goals.vue?vue&type=script&lang=ts"
export * from "./Goals.vue?vue&type=script&lang=ts"
import style0 from "./Goals.vue?vue&type=style&index=0&id=98dd31fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dd31fe",
  null
  
)

export default component.exports